import { render, staticRenderFns } from "./AlarmRecord.vue?vue&type=template&id=267f0e3a&"
import script from "./AlarmRecord.vue?vue&type=script&lang=js&"
export * from "./AlarmRecord.vue?vue&type=script&lang=js&"
import style0 from "./AlarmRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports